import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className", "icon", "additionalIcons", "fallback", "size"];
import * as React from 'react';
import clsx from 'clsx';
import Icons from '../assets/icons/icons.json';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesIconVariables = {
  small: '0.65em',
  base: '1em',
  medium: '1.5em',
  large: '1.65em',
  xlarge: '3em'
};
const Icon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    icon,
    additionalIcons,
    fallback,
    size = 'base'
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const getIcon = () => {
    // Merge in base icons with anything additional
    const iconSource = Object.assign(Icons, additionalIcons); // Match on fallback prop if supplied

    const matchedIcon = iconSource[icon] || iconSource[fallback]; // If we find an icon

    if (matchedIcon) {
      return ___EmotionJSX("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        css: [{
          // 1. Help against rendering bug when scaling
          lineHeight: '1',
          position: 'relative',
          top: '-0.1em',
          maxWidth: '100%',
          backfaceVisibility: 'hidden',
          // 1
          width: StylesIconVariables[size],
          height: StylesIconVariables[size],
          '.icon-fill': {
            fill: 'currentColor'
          },
          '.icon-stroke': {
            stroke: 'currentColor',
            strokeWidth: 1.5,
            vectorEffect: 'non-scaling-stroke',
            '*': {
              vectorEffect: 'non-scaling-stroke'
            }
          }
        }, process.env.NODE_ENV === "production" ? "" : ";label:getIcon;"],
        className: clsx('CK__Icon', className),
        ref: ref,
        dangerouslySetInnerHTML: {
          __html: matchedIcon
        }
      }, rest));
    }

    console.error('Icon not found'); // eslint-disable-line no-console

    return null;
  };

  return getIcon();
});
export default Icon;